import { Component, inject } from '@angular/core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** Login dialog component */
@Component({
	selector: 'g-login-dialog',
	templateUrl: './login-dialog.component.html',
	styleUrls: ['./login-dialog.component.scss'],
	standalone: false,
})
export class LoginDialogComponent {
	readonly modal = inject(NgbActiveModal);

	static readonly MAX_WIDTH = '700px';
	readonly icons = { faXmark };
	readonly dialogData?: { isAccountConfirmed: boolean };
}
